"use client";

import CorePriceComponent from "@core/helpers/client/components/price";
import { CURRENCY_LABEL, to_toman } from "@/helpers/price";

/**
 * جایگزین سراسری PriceComponent در ژومنت.
 *
 * مقدار ورودی همان ریالی است که از API می‌آید؛ اینجا به تومان تبدیل و با واحد
 * «تومان» نمایش داده می‌شود. بقیه‌ی props دقیقا مثل کامپوننت core عمل می‌کنند تا
 * جای‌گزینی در همه‌ی صفحه‌ها بدون تغییر دیگری ممکن باشد.
 */
const Price = ({ price, icon_component, ...props }) => (
	<CorePriceComponent
		{...props}
		price={to_toman(price)}
		icon_component={icon_component || CURRENCY_LABEL}
	/>
);

export default Price;
